<script>
// Name: upload-image
import Vue from 'vue'
import Component from './component'
Vue.component(
  'upload-image',
  Component
)
</script>



// WEBPACK FOOTER //
// index.vue?621eff3c